import React, { useEffect } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Login from './routes/login.js';
import { ThemeProvider } from '@material-ui/core/styles';
import { themeFactory } from '../src/themes';
import useToken from './useToken.js';
import Menu from './components/Menu/';
import MainView from './components/MainView';
import './App.css';
import { GeneralProvider } from './Context/GeneralContext.jsx';

export default function App() {
    const theme = themeFactory(process.env.REACT_APP_THEME);
    const { token, setToken, removeToken } = useToken();

    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--color-primary', theme.palette.primary.main);
        root.style.setProperty('--color-secondary', theme.palette.secondary.main);
        if (theme.palette.tertiary) {
            root.style.setProperty('--color-tertiary', theme.palette.tertiary.main);
        }
    }, [theme]);

    return (
        <ThemeProvider theme={theme}>
            {/*
              GeneralProvider siempre montado (fuera del condicional) para que:
              - isLoggingOutRef persista entre transiciones login ↔ app
              - El interceptor de fetch no se reinstale al cambiar de rama
              - removeToken() actualiza el estado aquí y React muestra el Login sin reload
            */}
            <GeneralProvider token={token} setToken={setToken} removeToken={removeToken}>
                {!token ? (
                    <Login setToken={setToken} />
                ) : (
                    <Router>
                        <div className="app-container">
                            <Menu />
                            <MainView />
                        </div>
                    </Router>
                )}
            </GeneralProvider>
        </ThemeProvider>
    );
}
